import { combine, withCallbacks } from 'react-hooks-combine'
import { spec, validators } from 'utils/validation'
import { withFormModel } from 'shared/hooks'

import MobileLoginFormComponent from './component'

const { string, any } = validators

export default combine(
	withFormModel(
		{
			email: {
				alias: 'Email',
				spec: spec.flow(
					string.isString,
					string.isEmail,
					string.isNotEmpty,
					any.required
				),
			},

			password: {
				alias: 'Password',
				spec: spec.flow(string.isString, string.isNotEmpty, any.required),
			},
		},
		{ id: 'mobile-login-form' }
	),

	withCallbacks(
		{
			onSubmitForm: {
				deps: ['onSubmit'],
				func:
					(_state, { onSubmit }) =>
						(entity) => {
							const { email, password } = entity
							return onSubmit({ email, password })
						},
			},
		},
		[]
	)
)(MobileLoginFormComponent) 